import gql from 'graphql-tag';

const GET_ACTIVE_SYSTEM_ALERTS = gql`
  query GetActiveSystemAlerts($now: DateTime!) {
    systemAlerts(
      where: {
        AND: [
          { active: true }
          { deleted: false }
          { startDate_lte: $now }
          { endDate_gte: $now }
        ]
      }
      orderBy: priority_DESC
    ) {
      id
      type
      message
      link
      linkText
      dismissible
      startDate
      endDate
      priority
    }
  }
`;

export default GET_ACTIVE_SYSTEM_ALERTS;
